import { Flex } from '@chakra-ui/react';
import React from 'react';

import { ChartTimePeriod } from './portfolioChartUtils';
import { IconButtonV2 } from '~/packages/common-frontend/components/IconButton';

type PortfolioTimePeriodSelectButtonsProps = {
  currentSelectedTimePeriod: ChartTimePeriod;
  onSelectTimePeriod: (timePeriod: ChartTimePeriod) => void;
};
export const PortfolioTimePeriodSelectButtons = ({
  currentSelectedTimePeriod,
  onSelectTimePeriod,
}: PortfolioTimePeriodSelectButtonsProps) => {
  return (
    <Flex gap="0.5rem">
      <IconButtonV2
        aria-label="Day"
        variant="primary-muted"
        colorScheme="gray"
        onClick={() => onSelectTimePeriod(ChartTimePeriod.day)}
        isActive={currentSelectedTimePeriod === ChartTimePeriod.day}
        icon={<span>D</span>}
      />
      <IconButtonV2
        aria-label="Week"
        variant="primary-muted"
        colorScheme="gray"
        onClick={() => onSelectTimePeriod(ChartTimePeriod.week)}
        isActive={currentSelectedTimePeriod === ChartTimePeriod.week}
        icon={<span>W</span>}
      />
      <IconButtonV2
        aria-label="Month"
        variant="primary-muted"
        colorScheme="gray"
        onClick={() => onSelectTimePeriod(ChartTimePeriod.month)}
        isActive={currentSelectedTimePeriod === ChartTimePeriod.month}
        icon={<span>M</span>}
      />
      <IconButtonV2
        aria-label="Quarter"
        variant="primary-muted"
        colorScheme="gray"
        onClick={() => onSelectTimePeriod(ChartTimePeriod.quarter)}
        isActive={currentSelectedTimePeriod === ChartTimePeriod.quarter}
        icon={<span>Q</span>}
      />
      <IconButtonV2
        aria-label="Year"
        variant="primary-muted"
        colorScheme="gray"
        onClick={() => onSelectTimePeriod(ChartTimePeriod.year)}
        isActive={currentSelectedTimePeriod === ChartTimePeriod.year}
        icon={<span>Y</span>}
      />
    </Flex>
  );
};
